var map = {
	"./comprehension_standard.svg": 107,
	"./evennumbers_standard.svg": 108,
	"./letterjumble_standard.svg": 109,
	"./lettermixup_standard.svg": 110,
	"./numbersearch_standard.svg": 111,
	"./numbersinput_standard.svg": 112,
	"./numberswarmup_standard.svg": 113,
	"./powerreader_standard.svg": 114,
	"./schulteletters_standard.svg": 115,
	"./schultemix_standard.svg": 116,
	"./schultenumbers_standard.svg": 117,
	"./sentencesinput_standard.svg": 118,
	"./sentenceswarmup_standard.svg": 119,
	"./textsearch_standard.svg": 120,
	"./wordpairs_standard.svg": 121,
	"./wordsearch_standard.svg": 122,
	"./wordsinput_standard.svg": 123,
	"./wordswarmup_standard.svg": 124,
	"./wpmtest_standard.svg": 125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;